<template>
    <page :showBackButton="true">
        <h1>Welchen Bereich betrifft dein Schaden?</h1>
        <slider currentPage="schadensmeldungNeu" />
        <expansion-card v-if="$store.state.isLoggedIn">
            <template v-slot:header>
                <b
                    >Im Schadensfall soll es schnell gehen. Melde uns deinen
                    Schaden schnell und bequem über das jeweilige Formular.</b
                >
            </template>
            Die erfassten Daten werden an die zuständige Abteilung gesendet und
            dort weiter verarbeitet. Bei Fragen, wende dich bitte an unsere
            <a href="tel:+4357070510" @click.stop>Schadenshotline</a>.
        </expansion-card>
        <expansion-card v-else>
            <template v-slot:header>
                <b
                    >Einige wichtige Dinge, die du bei deiner Schadensmeldung
                    beachten solltest!</b
                >
            </template>
            Als Kunde mit Login sparst du Zeit, wenn du dich jetzt anmeldest!
            Die erfassten Daten werden an die zuständige Abteilung gesendet und
            dort weiter verarbeitet. Bei Fragen, wende dich bitte an unsere
            <a href="tel:+4357070510">Schadenshotline</a>.
        </expansion-card>
        <ion-grid class="ion-padding-bottom">
            <ion-row>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung-kfz-neu' }"
                        icon="flame"
                        title="KFZ neu"
                    />
                </ion-col>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung-haushalt-neu' }"
                        icon="flame"
                        title="Haushalt & Eigenheim neu"
                    />
                </ion-col>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung-krankenhaus' }"
                        icon="flame"
                        title="Taggeld Krankenhaus"
                    />
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung-recht-neu' }"
                        icon="flame"
                        title="Rechtsschutz neu"
                    />
                </ion-col>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung-unfall' }"
                        icon="flame"
                        title="Unfallversicherung"
                    />
                </ion-col>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung-sach-neu' }"
                        icon="flame"
                        title="Sachvers. Unwetter neu"
                    />
                </ion-col>
            </ion-row>
            <!-- <ion-row>
                <ion-col size="4" offset="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung-sach-neu' }"
                        icon="flame"
                        title="Sachvers. Unwetter neu"
                    />
                </ion-col>
            </ion-row> -->
        </ion-grid>
        <h6 class="ion-margin-bottom">Deine Schadensmeldungen</h6>
        <ion-card
            class="c-contract-icon-card"
            :class="'-' + getMotivePath('', false)"
            button
            v-for="(fileGroup, index) in filteredFileGroups"
            :key="index"
            @click="openDokboxModal(fileGroup.index)"
        >
            <ion-grid>
                <ion-row>
                    <ion-col size="10" class="ion-padding">
                        <div class="c-contract-icon-card__title">
                            Haushaltsversicherung
                        </div>
                        {{ formatDate(fileGroup.date) }}
                    </ion-col>
                    <ion-col size="2" class="c-contract-icon-card__icon">
                        <span
                            :class="
                                'u-size-x-large icon-' +
                                getMotivePath('', false)
                            "
                            v-if="getMotivePath('', false) !== 'allgemein'"
                        ></span>
                        <span
                            class="u-size-x-large icon-pixelcloud"
                            v-else
                        ></span>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
        <!-- <ion-card class="c-contract-icon-card -mobilitaet" button>
            <ion-grid>
                <ion-row>
                    <ion-col size="10" class="ion-padding">
                        <div class="c-contract-icon-card__title">KFZ</div>
                        1. Mai 2019
                    </ion-col>
                    <ion-col size="2" class="c-contract-icon-card__icon">
                        <span class="u-size-x-large icon-mobilitaet"></span>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card> -->
    </page>
</template>

<script>
import Page from "@/components/Page";
import Pagelink from "@/components/Pagelink";
import ExpansionCard from "@/components/ExpansionCard";
import Slider from "@/components/Slider";
import { dokbox } from "@/mixins/dokbox";
import { isLoggedIn } from "../api/auth";
import { handleError } from "../utils/error";
import { DateFormatter } from "@/utils/date";
import DokboxModal from "@/components/DokboxModal";
import { motive } from "@/mixins/motive";

export default {
    mixins: [dokbox, motive],
    components: { Page, Pagelink, ExpansionCard, Slider },
    data() {
        return {
            damageReports: [],
            filterData: {
                limitStart: 0,
                limit: 50,
                limitCategories: [11],
            },
        };
    },
    mounted() {
        isLoggedIn()
            .then(() => {
                this.$store.dispatch("dokbox/getDokbox");
                this.$store
                    .dispatch("dokbox/getDokboxFiles", this.filterData)
                    .then((response) => {
                        this.damageReports = response.data.Result.files;
                    });
            })
            .catch((error) => {
                handleError(error);
            });
    },
    computed: {
        filteredFileGroups() {
            let result = [];
            for (let [index, fileGroup] of this.$store.getters[
                "dokbox/fileGroups"
            ].entries()) {
                if (fileGroup.categoryId === 11) {
                    fileGroup.index = index;
                    result.push(fileGroup);
                }
            }
            return result;
        },
        reset() {
            return this.$store.state.dokbox.reset;
        },
    },
    watch: {
        reset(value) {
            if (value) {
                this.$store.dispatch("dokbox/getDokboxFiles", this.filterData);
                this.$store.commit("dokbox/setReset", false);
            }
        },
    },
    methods: {
        formatDate(dateString) {
            return DateFormatter.formatDate(new Date(dateString), "DD.MM.YYYY");
        },
        openDokboxModal(fileGroupIndex) {
            this.$ionic.modalController
                .create({
                    component: DokboxModal,
                    componentProps: {
                        propsData: {
                            fileGroupIndex: fileGroupIndex,
                        },
                        parent: this,
                    },
                    backdropDismiss: false,
                })
                .then((m) => m.present());
        },
    },
};
</script>

<style lang="scss" scoped>
.c-pagelink {
    min-height: 105px;
}
</style>
